import React from "react";
import { Text, View } from "@react-pdf/renderer";

import SelectGroup from "../../../../exportacion_react_pdf/SelectGroup";
import QuestionResponse from "../../../../exportacion_react_pdf/QuestionResponse";
import CheckboxGroup from "../../../../exportacion_react_pdf/CheckboxGroup";
import TextAreaLabel from "../../../../exportacion_react_pdf/TextAreaLabel";
import TableGroup from "../../../../exportacion_react_pdf/TableGroup";

// Define el documento
const ExportAgricolaPaso6 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.title_1}>
                Características del predio Áreas en hectareas
            </Text>

            <QuestionResponse
                label={"Área en producción"}
                value={formData?.agricola?.area_produccion || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"Área en bosque, barbecho, huerta"}
                value={formData?.agricola?.area_bosque || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"Área del predio total"}
                value={formData?.agricola?.area_predio || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"N° de plantas sembradas"}
                value={formData?.agricola?.numero_plantas_sembradas || ""}
            ></QuestionResponse>
            <TextAreaLabel
                label={"Distancia de siembra"}
                value={formData?.agricola?.distancia_sembrada || ""}
            ></TextAreaLabel>
            <TextAreaLabel
                label={"¿Qué variedad o clon tiene sembrada?"}
                value={formData?.agricola?.variedad_sembrada || ""}
            ></TextAreaLabel>

            <SelectGroup
                label={"Época lluvia, mes para siembras"}
                selectedValue={formData?.agricola?.meses_siembra || ""}
            ></SelectGroup>




            <CheckboxGroup
                label="¿Cuenta actualmente con los equipos necesarios para la prestación de su servicio?"
                selectedValue={formData?.agricola?.manejo_registros || ""}
                options={['Sí', 'No', 'A veces']}
            ></CheckboxGroup>

            <TableGroup
                questionTitle="Comercialización (producto fresco, producto seco , procesados, semillas, plántulas, colinos, etc...)"
                headers={["producto", "cantidad_mes_ano", "venta_unidad", "cliente"]}
                headerDescriptions={["Producto", "Cantidad / mes/año", "Venta/unidad", "Cliente"]}
                data={formData?.agricola?.lista_comercializacion}
            />


        </View>



        <View style={styles.section}>
            <Text style={styles.title_1}>
                IDENTIFICACIÓN DE TÉCNICAS Y PRÁCTICAS AGRÍCOLAS
            </Text>

            <Text style={styles.title_1}>
                1. LÍNEA PRODUCTIVA
            </Text>
            <TableGroup
                questionTitle="Qué tipo de sistema productivo tiene?"
                headers={["tipo", "nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_sistema_productivo_tiene}
            />

            <TextAreaLabel
                label={"Edad del cultivo"}
                value={formData?.agricola?.edad_cultivo || ""}
            ></TextAreaLabel>


            <TextAreaLabel
                label={"Etapa fenológica del cultivo"}
                value={formData?.agricola?.etapa_fenologica_cultivo || ""}
            ></TextAreaLabel>

            <Text style={styles.title_1}>
                2. INFRAESTRUCTURA PRODUCTIVA
            </Text>

            <TableGroup
                questionTitle="Cuenta con una bodega u otro espacio para el almacenamiento de insumos, materiales y herramientas agrícolas"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_almacenamiento_infraestructura}
            />


            <TableGroup
                questionTitle="¿Cuenta con un lugar para realizar bioinsumos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_espacio_bioinsumos}
            />


            <TableGroup
                questionTitle="¿Cuenta con un espacio para dosificación y preparación de mezclas?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_espacio_dosificacion_mezclas}
            />

            <TableGroup
                questionTitle="¿Tiene reservorio de agua, tanque zamorano, jagüey y/o aljibe?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_reservorio_agua}
            />

            <TableGroup
                questionTitle="En caso que el cultivo requiera de tutorado (granadilla, fríjol), ¿tiene el tutorado y de qué tipo?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_tutorado_tipo}
            />


            <TableGroup
                questionTitle="¿Cuenta con infraestructura para el beneficio del café o cacao?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_infraestructura_cafe_cacao}
            />

            <TableGroup
                questionTitle="¿Cuenta con paseras para el secado del café o cacao?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_paseras_secado}
            />

            <TableGroup
                questionTitle="¿Cuenta con infraestructura para manejo postcosecha?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_infraestructura_postcosecha}
            />
            <TableGroup
                questionTitle="¿Cuenta con un vivero?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_vivero}
            />
            <TableGroup
                questionTitle="¿Cuenta con una compostera para residuos orgánicos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_compostera}
            />
            <TableGroup
                questionTitle="Instalaciones accesibles y adaptadas para personas en condición de discapacidad"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_instalaciones_accesibles}
            />


            <Text style={styles.title_1}>
                3. MAQUINARIA, EQUIPOS , HERRAMIENTAS
            </Text>

            <TableGroup
                questionTitle="¿Que tipo de maquinaria, equipos o herramientas tiene para la unidad productiva?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_maquinaria_equipo}
            />



            <Text style={styles.title_1}>
                4. USO Y MANEJO ADECUADO DEL SUELO Y LA FERTILIZACIÓN
            </Text>

            <TableGroup
                questionTitle="Cuenta con análisis de suelos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_cuenta_analisis_suelo}
            />


            <TableGroup
                questionTitle="Tiene en cuenta el análisis de suelos para realizar la fertilización de los cultivos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_cuenta_analisis_suelo_fertilizacion}
            />


            <CheckboxGroup
                label="Fertiliza los cultivos?"
                selectedValue={formData?.agricola?.fertiliza_cultivos || ""}
            ></CheckboxGroup>

            {formData?.agricola?.fertiliza_cultivos === 'Sí' && (
                <TableGroup
                    questionTitle="Con que tipo de insumos realiza la fertilización?"
                    headers={["tipo_insumo_fertilizacion","cuales"]}
                    headerDescriptions={["Tipo de fertilización", "Cuales"]}
                    data={formData?.agricola?.lista_tipo_insumos_fertiliza}
                />
            )}

            <TableGroup
                questionTitle="Aplica enmiendas al suelo?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_enmiendas}
            />

            <TableGroup
                questionTitle="Siembra en curvas de nivel?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_siembra_curvas_nivel}
            />

            <TableGroup
                questionTitle="¿Qué actividades realiza para la limpieza, trazad, preparación y manejo del terreno?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_actividades_manejo_terreno}
            />

            <TableGroup
                questionTitle="Hace uso de compostaje y acondicionamiento del suelo"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_uso_compostaje_acondicionamiento}
            />
            <TextAreaLabel
                label={"Observaciones generales categoria Uso y Manejo adecuado del suelo:"}
                value={formData?.agricola?.observaciones_uso_manejo_suelo || ""}
            ></TextAreaLabel>

            <Text style={styles.title_1}>
                5. SIEMBRA
            </Text>

            <TextAreaLabel
                label={"Que tipo de material vegetal utiliza o utilizó para la siembra ( plantas compradas en vivero, germino su propia semilla, compro semilla certificada, etc...)"}
                value={formData?.agricola?.tipo_material_vegetal_siembra || ""}
            ></TextAreaLabel>

            <TableGroup
                questionTitle="¿Qué acciones lleva a cabo en el manejo de las semillas?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_acciones_manejo_semillas}
            />


            <TableGroup
                questionTitle="¿Aplica métodos para la germinación de las semillas a cultivar?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_metodos_germinacion_semillas}
            />



            <TableGroup
                questionTitle="¿Aplica métodos para la germinación de las semillas a cultivar?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_metodos_germinacion_semillas}
            />


            <TableGroup
                questionTitle="Programa y realiza siembras escalonadas?"
                headers={["nivel_aplicacion", "observaciones"]}
                headheaderDescriptionsers={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_siembras_escalonadas}
            />


            <TableGroup
                questionTitle="Variedad o clon sembrado"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_variedad_clon_sembrado}
            />


            <TableGroup
                questionTitle="Distancia de siembra (entre plantas, entre calles)"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_distancia_siembra}
            />

            <TableGroup
                questionTitle="Aplica métodos de siembra y recomendaciones técnicas, según el cultivo"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_metodos_recomendaciones_siembra}
            />

            <TableGroup
                questionTitle="Incluye en la siembra especies nativas"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_especies_nativas_siembra}
            />

            <TableGroup
                questionTitle="Realiza prácticas de intercambio de semillas"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_intercambio_semillas}
            />

            <TextAreaLabel
                label={"Observaciones generales categoría Siembra"}
                value={formData?.agricola?.observaciones_siembra || ""}
            ></TextAreaLabel>


            <Text style={styles.title_1}>
                6. MANEJO INTEGRADO DE PLAGAS Y ENFERMEDADES y OTRAS LABORES
            </Text>

            <TableGroup
                questionTitle="Para el manejo de arvences, ¿Realiza desyerbas y plateos con enfoque conservacionista?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_desyerbas_plateos_conservacionistas}
            />

            <TableGroup
                questionTitle="¿Implementa métodos y técnicas para la prevención, control, eliminación o curación de las enfermedades que afectan los cultivos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_metodos_prevencion_control_enfermedades}
            />


            <TableGroup
                questionTitle="¿Implementa métodos y técnicas para la prevención, control de las plagas que afectan los cultivos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_metodos_prevencion_control_plagas}
            />


            <TableGroup
                questionTitle="Implementa prácticas culturales para manejo sanitario (podas, deshojes, siembra de plantas alelopáticas, etc.)"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_practicas_culturales_manejo_sanitario}
            />


            <TableGroup
                questionTitle="Si es el caso, ¿realiza los aportes adecuados?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_realiza_aportes}
            />



            <TableGroup
                questionTitle="Realiza prácticas de intercambio de semillas"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_intercambio_semillas_manejo_cultural}
            />


            <TextAreaLabel
                label={"Observaciones generales categoría Manejo cultural de cultivos"}
                value={formData?.agricola?.observaciones_manejo_cultural || ""}
            ></TextAreaLabel>

            <Text style={styles.title_1}>
                7. COSECHA Y POSCOSECH
            </Text>

            <TableGroup
                questionTitle="¿Cosecha en el momento adecuado el producto?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_cosecha_momento_adecuado}
            />

            <TableGroup
                questionTitle="¿Cuenta con herramientas y utensilios adecuados para la cosecha?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_herramientas_adecuadas_cosecha}
            />


            <TableGroup
                questionTitle="Aplica técnicas adecuadas para recolección del producto"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_tecnicas_adecuadas_recoleccion}
            />


            <TableGroup
                questionTitle="Dispone de un sitio adecuado para el almacenamiento de la cosecha"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_sitio_adecuado_almacenamiento_cosecha}
            />

            <TableGroup
                questionTitle="¿Cuál es el destino de la cosecha?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_destino_cosecha}
            />

            <TableGroup
                questionTitle="Realiza prácticas de intercambio de alimentos a nivel familiar/comunitario"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_intercambio_alimentos_familiar_comunitario}
            />


            <TextAreaLabel
                label={"Observaciones generales categoria Cosecha y Poscosecha"}
                value={formData?.agricola?.observaciones_cosecha_poscosecha || ""}
            ></TextAreaLabel>


            <Text style={styles.title_1}>
                8. MANEJO DE RESIDUOS
            </Text>


            <TableGroup
                questionTitle="¿La unidad productivas  genera residuos?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_generacion_residuos_unidad_productiva}
            />

            <TableGroup
                questionTitle="En el caso del cultivo de café y cacao, ¿tiene establecido un manejo para las aguas mieles?"
                headers={["nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.respuestas_manejo_aguas_mieles_cafe_cacao}
            />

            <TableGroup
                questionTitle="¿Qué tipo de manejo da a los residuos orgánicos? obtenidos?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_tipo_manejo_residuos}
            />

            <TableGroup
                questionTitle="¿Para qué tipo de práctica utiliza los residuos orgánicos?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_tipo_practica_utiliza_residuos}
            />

            <TableGroup
                questionTitle="¿Cuál es la principal fuente de agua?"
                headers={["tipo","nivel_aplicacion", "observaciones"]}
                headerDescriptions={["Sector", "Nivel aplicación", "Observaciones"]}
                data={formData?.agricola?.lista_principan_fuente_agua}
            />
        </View>
    </>
);

export default ExportAgricolaPaso6;
